const index = () => import('./Index');

//2021年生产性物流项目补助申请表
export default {
  routes: [
    {
      path: '/transportation/2022/index',
      name: 'transportation_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/logistics/v2022/router.js